var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalaryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_12093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.845 7.48417L19.4992 6.19583V2.91667C19.4992 1.30833 18.1908 0 16.5825 0H7.41583C5.8075 0 4.49917 1.30833 4.49917 2.91667V6.19833L3.15667 7.48417C2.42167 8.18833 2 9.17583 2 10.1925V20H21.9992V10.1925C21.9992 9.175 21.5783 8.1875 20.845 7.48417ZM8.66583 9.16667H11.1658V9.58333C11.1658 9.81333 11.3525 10 11.5825 10H12.4158C12.6458 10 12.8325 9.81333 12.8325 9.58333C12.8325 9.33833 12.685 9.12083 12.4575 9.02917L10.6117 8.29083C9.42917 7.81833 8.66583 6.68917 8.66583 5.41583C8.66583 4.09917 9.54833 2.99667 10.7492 2.635V1.66583H13.2492V2.635C14.45 2.99667 15.3325 4.09917 15.3325 5.41583V5.8325H12.8325V5.41583C12.8325 5.18583 12.6458 4.99917 12.4158 4.99917H11.5825C11.3525 4.99917 11.1658 5.18583 11.1658 5.41583C11.1658 5.66083 11.3133 5.87833 11.5408 5.97L13.3867 6.70833C14.5692 7.18083 15.3325 8.31 15.3325 9.58333C15.3325 10.9 14.45 12.0025 13.2492 12.3642V13.3333H10.7492V12.3642C9.54833 12.0025 8.66583 10.9 8.66583 9.58333V9.16667ZM19.4992 17.5H4.49917V10.2333L8.75833 14.4917C9.65167 15.385 10.825 15.8308 11.9992 15.8308C13.1733 15.8308 14.3467 15.3842 15.24 14.4908L19.4992 10.2317V17.5Z",
    fill: "#2E8056"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_12093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryIcon);
export default __webpack_public_path__ + "static/media/salaryIcon.afbd85bdebae30552d0e6c45fb9cdced.svg";
export { ForwardRef as ReactComponent };